<template>
    <div>
        <div class="form-field">
            <div class="info-field">
                <div class="info-field-text">{{ formattedText }}</div>
                <button
                    v-if="showDeleteButton"
                    style="float: right"
                    type="button"
                    @click="emitEvent({ name: 'remove', payload: index })"
                >
                    <common-icon name="trash-bin" size="medium"></common-icon>
                    {{ removeButtonText }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            removeButtonText: { type: String, default: undefined },
            index: { type: Number, default: undefined },
            text: { type: String, default: undefined },
            showDeleteButton: { type: Boolean, default: true },
        },
        computed: {
            formattedText() {
                return this.text.toUpperCase()
            },
        },
    }
</script>
<style scoped>
    .info-field {
        border-radius: 0.25rem;
        background-color: #f5f5f5;
        padding: 0.9375rem;
        color: black;
        width: 100%;
        height: 3.125rem;
        font-size: 0.875rem;
        line-height: 1.25rem;
        letter-spacing: 0.025em;
        font-weight: 500;
        border-color: #f5f5f5;
    }
    .info-field-text {
        display: inline-block;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>
